// extracted by mini-css-extract-plugin
export var textInput = "_dw-0";